import React from 'react';
import { motion } from 'framer-motion';
import { ShieldCheckIcon } from 'lucide-react';
export function GuaranteeSection() {
  return <section className="border-y border-accent/15 bg-surface/40 py-16 sm:py-20" aria-labelledby="guarantee-title" data-id="element-73" data-mp="4vs0rz0u8fre">
      <div className="mx-auto max-w-2xl px-4 text-center" data-id="element-74" data-mp="9t1ptdkbepep">
        <motion.div initial={{
        opacity: 0,
        y: 14
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.3,
        ease: [0.23, 1, 0.32, 1]
      }} className="rounded-3xl border-2 border-accent/40 bg-background/60 p-8 shadow-2xl shadow-black/40 sm:p-12" data-id="element-75" data-mp="etplicjhnuf9">
          <span className="inline-flex rounded-full border border-accent/50 bg-surface/60 p-4 text-accent" data-id="element-76" data-mp="sn6yfeho68wb">
            <ShieldCheckIcon className="h-10 w-10" aria-hidden="true" data-id="element-77" data-mp="12j0dp5mrwghs" />
          </span>
          <h2 id="guarantee-title" className="mt-6 text-balance text-3xl font-extrabold uppercase tracking-tight text-foreground sm:text-4xl" data-id="element-78" data-mp="12h78lurt64bw">
            Garanzia di soddisfazione <span className="text-primary" data-id="element-79" data-mp="25ti1o7ch62u7">di 7 giorni</span>
          </h2>
          <p className="mt-4 text-lg leading-relaxed text-muted" data-id="element-80" data-mp="20rspuphfhl52">
            Se entro 7 giorni il materiale non fa per te,{' '}
            <span className="font-extrabold text-primary" data-id="element-81" data-mp="1vu0zhzwfm72z">ti rimborsiamo. Senza domande.</span>
          </p>
        </motion.div>
      </div>
    </section>;
}